<template>
  <v-app data-testid="app" :style="appStyles">
    <v-main>
      <AppBar
        v-if="
          route.path !== '/login' &&
          !route.path.includes('/approval-proposal') &&
          !route.path.includes('/approval-requisition') &&
          !route.path.includes('/checklist-vehicle') &&
          !route.path.includes('/approval-techlist-purchase-request') &&
          !route.path.includes('/assinar-proposta')
        "
        style="z-index: 7"
      />

      <transition name="fadeRouter" mode="out-in">
        <router-view />
      </transition>
    </v-main>

    <SessionExpiredDialog />
    <ReloadDialog />
    <AtmoAssistantDialog />
  </v-app>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "@/composables";

import AppBar from "@/components/AppBar";
import AtmoAssistantDialog from "@/components/assistant/AtmoAssistantDialog.vue";
import SessionExpiredDialog from "@/components/znap/SessionExpiredDialog";
import ReloadDialog from "@/components/znap/ReloadDialog";

const route = useRoute();

const appStyles = computed(() => {
  return {
    background: "#ddd",
    "background-image": 'url("/img/background.png")',
    "background-position": "center",
    "background-repeat": "no-repeat",
    "background-size": "cover",
    "-webkit-background-size": "cover",
    "-moz-background-size": "cover",
    "-o-background-size": "cover",
    "overflow-y": "hidden",
    "scroll-behavior": "smooth",
    "line-height": route.path.includes("editor") ? "1.2" : "1.5",
  };
});
</script>

<style>
:root {
  --primary-color: #2b81d6;
}

html {
  scroll-behavior: smooth;
}

.v-navigation-drawer {
  z-index: 10000 !important;
}

.cursor-pointer {
  cursor: pointer !important;
}

.theme--dark .v-data-table tbody tr.selected-row,
.theme--dark .v-data-table tbody tr.v-data-table__selected {
  background-color: rgba(255, 255, 255, 0.12) !important;
}

.theme--dark .v-data-table tbody tr.selected-row:hover,
.theme--dark .v-data-table tbody tr.v-data-table__selected:hover {
  background-color: rgba(255, 255, 255, 0.2) !important;
}

.theme--dark .v-data-table tbody tr.selected-row > td,
.theme--dark .v-data-table tbody tr.v-data-table__selected > td {
  color: rgba(255, 255, 255, 0.87) !important;
}
</style>

<style scoped>
/* #app {
  background: #ddd;
  background-image: url("../public/img/background.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  overflow-y: hidden;
  scroll-behavior: smooth;
} */

body {
  overflow-y: hidden !important;
}

.fadeRouter-enter {
  opacity: 0;
}

.fadeRouter-enter-active {
  transition: opacity 0.28s ease;
}

.fadeRouter-leave-active {
  transition: opacity 0.28s ease;
  opacity: 0;
}

.v-img {
  display: flex !important;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;
}
</style>
